import React from 'react';

const pageTitles = {
    home: 'Beranda',
    assessmentHub: 'Pusat Pemeriksaan',
    stimulation: 'Panduan Stimulasi',
    education: 'Pojok Edukasi',
    profile: 'Profil Saya',
    addChild: 'Tambah Data Anak',
    editChild: 'Ubah Data Anak',
    viewChild: 'Detail Anak',
    singleAssessment: 'Mulai Pemeriksaan',
    results: 'Hasil Pemeriksaan',
    accessSharedData: 'Akses Data Bersama',
    editProfile: 'Ubah Profil',
    reportCard: 'Rapor Tumbuh Kembang',
    createIntervention: 'Buat Rencana Intervensi',
    notifications: 'Notifikasi',
};

export default function Header({ page, user, navigate, onBack, notificationCount = 0 }) {
    const title = pageTitles[page] || 'SDIDTK';
    const showBackButton = ![
        'home', 
        'assessmentHub', 
        'stimulation', 
        'education', 
        'profile'
    ].includes(page);

    const handleBack = () => {
        if (onBack) {
            onBack();
        }
    };

    return (
        <header className="sticky top-0 z-50 bg-white/50 backdrop-blur-2xl border-b border-white/60 shadow-[0_4px_30px_rgba(0,0,0,0.03)] px-5 py-3 flex items-center justify-between transition-all duration-300">
            <div className="flex items-center space-x-4">
                {showBackButton && (
                    <button 
                        onClick={handleBack} 
                        className="w-10 h-10 flex items-center justify-center rounded-[1rem] bg-white/60 border border-white/80 shadow-sm text-gray-700 hover:bg-white hover:text-sky-600 transition-all active:scale-95 group"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 transform group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                )}
                <h1 className="text-xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-gray-800 to-gray-600 tracking-tight">{title}</h1>
            </div>
            
            {user && (
                <button 
                    onClick={() => navigate('notifications')} 
                    className="relative w-10 h-10 flex items-center justify-center rounded-[1rem] bg-white/60 border border-white/80 shadow-sm text-gray-600 hover:bg-white hover:text-sky-600 transition-all active:scale-95"
                >
                     <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                    {notificationCount > 0 && (
                        <span className="absolute -top-1.5 -right-1.5 flex h-5 w-5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-5 w-5 bg-gradient-to-br from-rose-500 to-pink-500 items-center justify-center text-[10px] font-bold text-white shadow-sm border border-rose-200">
                                {notificationCount}
                            </span>
                        </span>
                    )}
                </button>
            )}
        </header>
    );
}
